import * as React from "react";
const SvgFiRrCamcorder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M14 10H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1m-1 8H6v-6h7zm9.88-9.007a2.02 2.02 0 0 0-2.125.191l-1.802 1.352C18.715 7.999 16.598 6 14 6h-.073L9.806 1.879A2.98 2.98 0 0 0 7.685 1H1a1 1 0 1 0 0 2h6.685c.263 0 .521.107.707.293L11.099 6H5c-2.757 0-5 2.243-5 5v8c0 2.757 2.243 5 5 5h9c2.598 0 4.714-1.999 4.953-4.535l1.802 1.352a2.02 2.02 0 0 0 2.124.191A2.02 2.02 0 0 0 24 19.194v-8.387a2.02 2.02 0 0 0-1.12-1.814M17 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-8c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3zm4.954.216L19 17v-3.995l2.999-2.213v.015z"
    />
  </svg>
);
export default SvgFiRrCamcorder;
